import { render, staticRenderFns } from "./BulkIndexContractServiceFee.yaml?vue&type=template&id=440a1b72&component"
import script from "./BulkIndexContractServiceFee.yaml?vue&type=script&lang=ts&component"
export * from "./BulkIndexContractServiceFee.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports